import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_8 = { class: "table table-bordered" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = ["onClick"]

import { computed, toRef } from 'vue'

    import type { DisagreementsDialogViewModel } from '@Evaluation/Estimations/Components/DisagreementsDialog'
    import type { DisagreementItem } from '@Evaluation/Estimations/Domain/readmodels'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DisagreementsDialog',
  props: {
    viewModel: {}
  },
  emits: ["switch-question"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened)
    const initialized = computed(() => vm.value.initialized)
    const questions = computed(() => vm.value.questions)

    // ---------------- actions ----------------

    function switchQuestion(q: DisagreementItem)
    {
        emit('switch-question', q.QuestionId)
        close()
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Disagreements", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("table", _hoisted_8, [
                        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, " Alternative "),
                            _createElementVNode("th", null, " Attribute "),
                            _createElementVNode("th", null, " Disagreement "),
                            _createElementVNode("th")
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (q) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: q.QuestionId
                            }, [
                              _createElementVNode("td", null, _toDisplayString(q.AlternativeName), 1 /* TEXT */),
                              _createElementVNode("td", null, _toDisplayString(q.AttributeName), 1 /* TEXT */),
                              _createElementVNode("td", null, _toDisplayString(q.DisagreementLabel), 1 /* TEXT */),
                              _createElementVNode("td", _hoisted_9, [
                                _createElementVNode("a", {
                                  class: "text-primary",
                                  onClick: ($event: any) => (switchQuestion(q))
                                }, "show", 8 /* PROPS */, _hoisted_10)
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})